<template>
  <div class="content">
    <div class="search-area pt1">
      <p class="t-left font-S16">基本信息</p>
      <el-row :gutter="24">
        <el-col :span="5">
          <div class="search-area-div-text"><span class="fontC-bcbec2">医院：</span>{{ queryData.medName }}</div>
        </el-col>
        <el-col :span="8">
          <div class="search-area-div-text">
            <span class="fontC-bcbec2">供应商：</span>{{ queryData.supplierName }}
          </div>
        </el-col>
        <el-col :span="5">
          <div class="search-area-div-text"><span class="fontC-bcbec2">年度：</span>{{ queryData.year }}年</div>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="mt15">
        <el-col :span="5">
          <div class="search-area-div-text"><span class="fontC-bcbec2">月份：</span>{{ queryData.month }}月</div>
        </el-col>
        <el-col :span="8">
          <div class="search-area-div-text">
            <span class="fontC-bcbec2">运营费总额：</span>{{ totalAmount | numFmt | numDigit }}
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="button-area pt1">
      <p class="t-left font-S16">费用信息</p>
    </div>
    <div class="back-color-fff" style="padding: 16px; padding-bottom: 80px">
      <el-table :data="tableData" style="width: 100%" row-key="guid" border v-loading="tableLoading">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="goodsName" label="商品" header-align="center" align="left" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="goodsSpec" width="200" label="规格" header-align="center" align="left" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="rateType" label="费率方式" width="150" header-align="center" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.rateType | getRateType }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="rate" label="费率（％）" width="200" header-align="center" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.rateType == '3'">-</span>
            <span v-else>{{ scope.row.rate }}</span>
          </template>
        </el-table-column>
        <el-table-column label="结算金额" header-align="center" align="right" width="200">
          <template slot-scope="scope">{{ scope.row.settleAmount | numFmt | numDigit }}</template>
        </el-table-column>
        <el-table-column label="运营费用" header-align="center" align="right" width="200">
          <template slot-scope="scope">{{
            scope.row.amount | numFmt | numDigit
          }}</template>
        </el-table-column>

      </el-table>
    </div>
    <div class="bottom-total">
      <div class="total-right fr">
        <el-button size="medium" type="default" class="mr15 mt15" @click="report()">导出费用信息</el-button>
        <el-button size="medium" type="danger" class="mr15 mt15" @click="dialogVisible = true">重新计算</el-button>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <div class="dialogBox">
        <i class="el-icon-warning"></i><span>重新计算?</span>
        <p class="font-S14">1、对系统自动计算的费用有疑问可以操作此功能</p>
        <p class="font-S14">2、请确认该供应商的运营费率是否设置完成</p>
        <p class="font-S14">3、重新计算后仍有疑问，可联系技术解决</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="info" @click="getRecalculate">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      queryData: {},
      totalAmount: 0,
      tableLoading: false,
      dialogVisible: false,
    };
  },
  created() {
    this.getData();
    this.queryData = JSON.parse(this.$route.query.queryData);
  },
  methods: {
    getData() {
      let self = this;
      self.tableLoading = true;
      this.queryData = JSON.parse(this.$route.query.queryData);
      let medGuid = self.$store.state.medGuid;
      let supplierGuid = self.queryData.guid;
      let yearMonth = self.queryData.yearMonth;
      let settleBillno = self.queryData.settleBillno;
      self.api
        .get(
          `/${serverConfig.msDataBusinessService}/operating-costs/get-operating-costs-detail?medGuid=` +
          medGuid +
          '&supplierGuid=' +
          supplierGuid +
          '&yearMonth=' +
          yearMonth +
          '&settleBillno=' +
          settleBillno,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tableLoading = false;
            this.tableData = res.data.data;
            if (self.tableData !== null || self.tableData !== []) {
              self.tableData.forEach((item, index) => {
                item.rate = (item.rate * 100).toFixed(2);
              });
              self.totalAmount = self.tableData.reduce((total, current) => {
                return total + current.amount;
              }, 0);
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getRecalculate() {
      let self = this;
      let promise = {
        medGuid: self.$store.state.medGuid,
        supplierGuid: self.queryData.guid,
        yearMonth: self.queryData.yearMonth,
      };
      self.api.put(`/${serverConfig.msDataBusinessService}/operating-costs/operating-costs-recalculate`, promise).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.getData();
          self.$message({
            type: 'success',
            message: '重算成功!',
          });
        } else {
          self.$message.error('重算失败！');
        }
      });
    },
    reportJx(colNames, datas, sheetName, fileNam) {
      let self = this;
      self.api
        .postJsonD('/ms-common-admin-cloud-service/excel/export', {
          colNames: colNames,
          datas: datas,
          sheetName: sheetName,
          fileNam: fileNam,
        })
        .then((res) => {
          let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let fileName = fileNam;
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.download = fileName;
          link.href = objectUrl;
          link.click();
        });
    },
    report() {
      let self = this;
      let medGuid = self.$store.state.medGuid;
      let supplierGuid = self.queryData.guid;
      let yearMonth = self.queryData.yearMonth;
      self.api.get(`/${serverConfig.msDataBusinessService}/operating-costs/operating-costs-detail-export?medGuid=` +
        medGuid +
        '&supplierGuid=' +
        supplierGuid +
        '&yearMonth=' +
        yearMonth).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            console.log(res.data)
            self.reportJx(res.data.data.colNames, res.data.data.datas, res.data.data.sheetName, res.data.data.fileNam);
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
  },

  // //搜索
  // searchData() {
  //   let self = this;
  //   self.getData();
  // },
  // handleSizeChange(val) {
  //   let self = this;
  //   self.page.pageSize = val;
  //   this.getData();
  // },
  // handleCurrentChange(val) {
  //   let self = this;
  //   self.page.pageIndex = val;
  //   this.getData();
  // },
};
</script>
<style scoped>
.bottom-total {
  box-sizing: border-box;
  position: fixed;
  width: calc(100% - 201px);
  height: 64px;
  bottom: 0;
  right: 0;
  padding-left: 18px;
  background: #fff;
  /* box-shadow: 4px 5px 6px 7px rgba(0, 0, 0, 0.3); */
  /* z-index: 999; */
  overflow: hidden;
  border: 1px solid #e3e4e6;
  /* border-radius: 6px; */
}

.el-select-dropdown__item.selected {
  color: #333;
  font-weight: 400;
}

.dialogBox {
  font-size: 16px;
  text-align: left;
}

.el-icon-warning {
  color: #e6a23c;
  font-size: 20px;
  margin-right: 10px;
}

/deep/.el-dialog {
  border-radius: 4px;
}
</style>
